// services/jurnalMingguanService.js
import axios from "axios";
import { ApiConfig } from "../constants/apiConfig";
import { studentHeaders } from "./apiClient";

export const fetchJurnalMingguan = async (siswaId, page = 1, perPage = 2) => {
  try {
    const response = await axios.get(`${ApiConfig.baseUrl}/jurnal-mingguan`, {
      params: {
        page: page,
        per_page: perPage,
      },
      headers: {
        ...studentHeaders(),
        Accept: "application/json",
      },
    });

    if (response.status === 200 && response.data.success) {
      return {
        success: true,
        data: response.data.data,
      };
    } else {
      return {
        success: false,
        message: response.data.message || "Gagal mengambil data jurnal mingguan",
      };
    }
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.message ||
        "Terjadi kesalahan saat mengambil data jurnal mingguan",
    };
  }
};

export const fetchJurnalMingguanFoto = async (fotoId) => {
  const response = await axios.get(
    `${ApiConfig.baseUrl}/jurnal-mingguan/foto/${fotoId}`,
    {
      headers: studentHeaders({ Accept: "image/*" }),
      responseType: "blob",
    }
  );

  return URL.createObjectURL(response.data);
};

export const downloadJurnalMingguanPDF = async (siswaId, mingguKe) => {
  try {
    const response = await fetch(
      `${ApiConfig.baseUrl}/export/jurnal-mingguan/download?siswa_id=${siswaId}&minggu_ke=${mingguKe}`,
      {
        headers: {
          ...studentHeaders(),
        },
      }
    );

    if (!response.ok) {
      throw new Error("Gagal mendownload file");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Jurnal_Mingguan_Minggu_${mingguKe}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();

    return { success: true };
  } catch (error) {
    console.error("Download error:", error);
    return {
      success: false,
      message: "Terjadi kesalahan saat mendownload file.",
    };
  }
};
export const ajukanJurnalMingguan = async (formData) => {
  try {
    const response = await axios.post(
      `${ApiConfig.baseUrl}/jurnal-mingguan`,
      formData,
      {
        headers: {
          ...studentHeaders(),
        },
      }
    );

    return response.data.success
      ? { success: true }
      : { success: false, message: response.data.message };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.message ||
        "Terjadi kesalahan saat mengirim data jurnal.",
    };
  }
};
